import React from "react";
import { TableRow, TableCell, Typography } from "@mui/material";
import { PriceModel } from "./data/PriceModel";
import { styled } from "@mui/system";

interface EnergyTypeRowProps {
  priceData: PriceModel[];
}

const CustomTableCell = styled(TableCell)({
  padding: '9px', // Adjust the padding as needed
});

/**
 * Component that renders a table row with Energy Type information for each `PriceModel` item.
 *
 * @param {EnergyTypeRowProps} props - The props for the component.
 * @param {PriceModel[]} props.priceData - The array of `PriceModel` objects containing the data to display.
 * @returns {React.ReactElement} - A `TableRow` element containing table cells with unit information.
 */
const EnergyTypeRow: React.FC<EnergyTypeRowProps> = ({
  priceData,
}: EnergyTypeRowProps): React.ReactElement => (
  <TableRow>
    <CustomTableCell>Energy Type</CustomTableCell>
    {priceData.map((item) => (
      <CustomTableCell key={item.id}>
         <Typography variant="body2">
          {item.energyType}
        </Typography>
        
      </CustomTableCell>
    ))}
  </TableRow>
);

export default EnergyTypeRow;